import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import reducer from '../reducers';
import { loggerMiddleware } from './middlewares/logger';
import { promise } from './middlewares/promise';
import { pagesReduxMiddleware } from './middlewares/pagesRedux';

const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

// ##### Komarov 2025-09-03
const middlewares = applyMiddleware(loggerMiddleware, thunk, promise, pagesReduxMiddleware);

const store = createStore(
  reducer,
  window.INITIAL_STATE ? window.INITIAL_STATE : {},
  composeEnhancers(middlewares)
);

export default store;
